<template>
    <BasePanel :alvqa="alvqa" headline="lang_GENERIC_CAPTION_OTHER_IDS">
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
                :page.sync="currentPage"
            >
            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.sourceAlvId`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-source-alv-id'">
                        {{ getSourceName(item) }}
                    </div>
                </template>
                <template v-slot:[`item.otherId`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-other-id'">
                        {{ item.otherId }}
                    </div>
                </template>
            </v-data-table>
            <v-pagination
                v-if="numberOfPages > 1"
                total-visible="10"
                v-model="currentPage"
                :length="numberOfPages"
                color="pagination"
            ></v-pagination>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'

export default {
    name: "ReleasesOtherIdsReadOnlyPanel",
    components: {
        BasePanel,
    },
    props: {
        releaseAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'label-releases-list-row-' + this.releaseAlvId + '-read-only-panel-other-ids',
            currentPage: 1
        }
    },
    computed: {
        sourceOptions() {
            return this.$store.getters.getAzForOtherIdsSource
        },
        listItems() {
            let item = this.$store.getters.getExpandedLabelReleases.find(element => {
                return element.alvId === this.releaseAlvId
            })

            return item && item.otherIds ? item.otherIds : []
        },
        headers() {
            return [
                {
                    text: this.$t("lang_GENERIC_CAPTION_SOURCE"),
                    align: "left",
                    value: "sourceAlvId",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-source'
                },
                {
                    text: this.$t("lang_LABEL_RELEASES_CAPTION_OTHER_ID"),
                    align: "left",
                    value: "otherId",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-other-id'
                }
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        numberOfPages() { return Math.ceil(this.listItems.length / this.itemsPerPage) },
    },
    methods: {
        getSourceName(item) {
            if (!item.sourceAlvId) return ''
            const found = (this.sourceOptions || []).find(o => o.value === item.sourceAlvId)
            if (found) return found.text + " (" + item.sourceAlvId + ")"
            if (item.sourceObject) return this.$alvPlugin.showNameOfAzEntry(item.sourceObject) + " (" + item.sourceAlvId + ")"
            return item.sourceAlvId
        }
    },
    created() {
        if (!this.sourceOptions || this.sourceOptions.length === 0) this.$store.dispatch("fetchAzForOtherIdsSource")
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>
